/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { BulkCreateStudentsReq } from '../_model/bulkCreateStudentsReq';
import type { LoginWithUserCodeReq } from '../_model/loginWithUserCodeReq';
import type { SuccessBodyBulkCreateStudentsRes } from '../_model/successBodyBulkCreateStudentsRes';
import type { SuccessBodyLoginWithUserCodeRes } from '../_model/successBodyLoginWithUserCodeRes';
import type { SuccessBodyStudentCardListRes } from '../_model/successBodyStudentCardListRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * 진입 코드 검증 후 직접 로그인(public)
 */
export const loginWithUserCode = (
  loginWithUserCodeReq: BodyType<LoginWithUserCodeReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyLoginWithUserCodeRes>(
    {
      url: `/user-code/verify`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginWithUserCodeReq,
      signal,
    },
    options,
  );
};

export const getLoginWithUserCodeMutationKey = () =>
  ['loginWithUserCode'] as const;

export const getLoginWithUserCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithUserCode>>,
    TError,
    LoginWithUserCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithUserCode>>,
  TError,
  LoginWithUserCodeMutationVariables,
  TContext
> => {
  const mutationKey = getLoginWithUserCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithUserCode>>,
    LoginWithUserCodeMutationVariables
  > = props => {
    const { data } = props ?? {};

    return loginWithUserCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithUserCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithUserCode>>
>;
export type LoginWithUserCodeMutationBody = BodyType<LoginWithUserCodeReq>;
export type LoginWithUserCodeMutationError = ErrorType<unknown>;
export type LoginWithUserCodeMutationVariables = {
  data: BodyType<LoginWithUserCodeReq>;
};

export const useLoginWithUserCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof loginWithUserCode>>,
      TError,
      LoginWithUserCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof loginWithUserCode>>,
  TError,
  LoginWithUserCodeMutationVariables,
  TContext
> => {
  return useMutation(getLoginWithUserCodeMutationOptions(options), queryClient);
};
/**
 * 진입 코드 학생 N명 일괄 생성(소유 학급)
 */
export const bulkCreateStudentsWithCode = (
  classGroupId: string,
  bulkCreateStudentsReq: BodyType<BulkCreateStudentsReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBulkCreateStudentsRes>(
    {
      url: `/classrooms/${classGroupId}/students/bulk-code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkCreateStudentsReq,
      signal,
    },
    options,
  );
};

export const getBulkCreateStudentsWithCodeMutationKey = () =>
  ['bulkCreateStudentsWithCode'] as const;

export const getBulkCreateStudentsWithCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>,
    TError,
    BulkCreateStudentsWithCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>,
  TError,
  BulkCreateStudentsWithCodeMutationVariables,
  TContext
> => {
  const mutationKey = getBulkCreateStudentsWithCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>,
    BulkCreateStudentsWithCodeMutationVariables
  > = props => {
    const { classGroupId, data } = props ?? {};

    return bulkCreateStudentsWithCode(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCreateStudentsWithCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>
>;
export type BulkCreateStudentsWithCodeMutationBody =
  BodyType<BulkCreateStudentsReq>;
export type BulkCreateStudentsWithCodeMutationError = ErrorType<unknown>;
export type BulkCreateStudentsWithCodeMutationVariables = {
  classGroupId: string;
  data: BodyType<BulkCreateStudentsReq>;
};

export const useBulkCreateStudentsWithCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>,
      TError,
      BulkCreateStudentsWithCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCreateStudentsWithCode>>,
  TError,
  BulkCreateStudentsWithCodeMutationVariables,
  TContext
> => {
  return useMutation(
    getBulkCreateStudentsWithCodeMutationOptions(options),
    queryClient,
  );
};
/**
 * 소유 학급의 코드 학생 카드 목록
 */
export const getStudentCards = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyStudentCardListRes>(
    { url: `/classrooms/${classGroupId}/student-cards`, method: 'GET', signal },
    options,
  );
};

export const getGetStudentCardsQueryKey = (classGroupId: string) => {
  return [`/classrooms/${classGroupId}/student-cards`] as const;
};

export const getGetStudentCardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentCardsQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentCards>>> = ({
    signal,
  }) => getStudentCards(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: classGroupId !== null && classGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStudentCardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentCards>>
>;
export type GetStudentCardsQueryError = ErrorType<unknown>;

export function useGetStudentCards<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentCards>>,
          TError,
          Awaited<ReturnType<typeof getStudentCards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudentCards<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentCards>>,
          TError,
          Awaited<ReturnType<typeof getStudentCards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudentCards<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetStudentCards<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStudentCardsQueryOptions(classGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetStudentCardsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentCardsQueryKey(classGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentCards>>> = ({
    signal,
  }) => getStudentCards(classGroupId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getStudentCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetStudentCardsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentCards>>
>;
export type GetStudentCardsSuspenseQueryError = ErrorType<unknown>;

export function useGetStudentCardsSuspense<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudentCardsSuspense<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudentCardsSuspense<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetStudentCardsSuspense<
  TData = Awaited<ReturnType<typeof getStudentCards>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStudentCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStudentCardsSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
